import { Injectable } from '@angular/core';
import { BreakParamSearch, ButtonParamSearch, CheckboxParamSearch, CustomSearch, DatePickerParamSearch, FloatParamSearch, ITEM_TYPE, MultiSelectParamSearch, NumberParamSearch, SelectParamSearch, Select_MoreParamSearch, TextParamSearch } from '../advanced-search.component';


export interface AdvSearchProps{
  advanced_search?: boolean,  // Ricerca avanzata
  view_advance_search?:boolean,
  defaultItemClass?: "col" | "col-1" | "col-2" | "col-3"| "col-4"| "col-5" | "col-6" | "col-7"| "col-8"| "col-9"| "col-10"| "col-11"| "col-12", /// col class
  header : ParamSearch[],
  //  ParamSearch[], // Sempre visibile
  body? : ParamSearch[] // Visibile se advanced_search = true
}


export interface ParamSearch{
  id : string,         // id itemm
  label? : string,     // Label Item
  visible? : boolean,  // Visibilità item
  initValue?: any,     // Valore iniziale

  select_values?: {key: string, value: string}[],  // SOLO PER SELECT
  multi_select_values?: {key: string, value: string, selected?: boolean}[], // Multi Select
  select_more_values?: {key: string, value: string, body: ParamSearch[]}[]    // Select + altro
  
  type: ITEM_TYPE,
  // Attributi stile item
  placeholder? : string //Placeholder item,
  nameClass?: string,   // Stile item
  columnClass?: "col" | "col-1" | "col-2" | "col-3"| "col-4"| "col-5" | "col-6" | "col-7"| "col-8"| "col-9"| "col-10"| "col-11"| "col-12",
  tooltip?: string,
  positionLabel?: "top" | "left"|"right",
  value?: any
}

@Injectable({
  providedIn: 'root'
})
export class AdvSearch {

  private configAdv : CustomSearch | undefined;

  constructor() {}


  public setAdvSearch(config: AdvSearchProps){
    this.generateConfigAdv(config);
  }
  

  private generateConfigAdv(config: AdvSearchProps){
    let finalConfig : CustomSearch = {
      advanced_search: config.advanced_search,
      view_advance_search: config.view_advance_search,
      defaultItemClass: config.defaultItemClass,
      header: [],
      body: []
    };

    this.generateObj(config.header!, finalConfig.header!);
    this.generateObj(config.body!, finalConfig.body!);

    
    this.configAdv = finalConfig;
  }


  private generateObj(ps: ParamSearch[], list : (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch | ButtonParamSearch | BreakParamSearch)[]){
    ps.forEach(e => {
      switch(e.type){
        case ITEM_TYPE.TEXT:
          let txtps = new TextParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          txtps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(txtps);
          break;

        case ITEM_TYPE.NUMBER:
          let nps = new NumberParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          nps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(nps);
          break;
        
        case ITEM_TYPE.FLOAT:
          let fps = new FloatParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          fps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(fps);
          break;

        case ITEM_TYPE.SELECT:
          let sps = new SelectParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          e.select_values?.forEach(i => sps.addValues(i.key, i.value));
          sps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(sps);
          break;
        
        
        case ITEM_TYPE.MULTI_SELECT:
          let msps = new MultiSelectParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          e.multi_select_values?.forEach(i => msps.addValues(i.key, i.value, i.selected ? i.selected: false));
          msps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(msps);
          break;

        case ITEM_TYPE.CHECKBOX:
          let ckps = new CheckboxParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          ckps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(ckps);
          break;

        case ITEM_TYPE.DATE_PICKER:
          let dtps = new DatePickerParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          dtps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(dtps);
          break;
        
        case ITEM_TYPE.BUTTON:
          let btnps = new ButtonParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          btnps.labelPosition = e.positionLabel ? e.positionLabel : "top";
          list.push(btnps);
          break;
        
        case ITEM_TYPE.BREAK:
          let brkps = new BreakParamSearch(e.id);
          list.push(brkps);
          break;

        case ITEM_TYPE.SELECT_MORE:
          let slct_more_ps = new Select_MoreParamSearch(e.id, e.label, e.visible ? e.visible : true, e.placeholder, e.nameClass, e.tooltip, e.initValue);
          e.select_more_values!.forEach(i => {
            let listBody :  (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch)[] = [];
            this.generateObj(i.body, listBody);
            slct_more_ps.addValues(i.key, i.value, listBody);
          });
          list.push(slct_more_ps);
          break;
      }
    })
  }


  public getConfigAdv(): CustomSearch| undefined{
    // console.log(this.configAdv);
    return this.configAdv;
  }

}
